import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

// استيراد صور الشهادات
import certCoursera from "../../Assets/cert_cleaned_1.png";
import certSC900 from "../../Assets/cert_cleaned_2.png";
import certAZ104 from "../../Assets/cert16.png";
import certAZ900 from "../../Assets/cert_cleaned_4.png";
import certCS50SQL from "../../Assets/cert_cleaned_5.png";
import certCS50x from "../../Assets/cert_cleaned_6.png";
import certISC2 from "../../Assets/cert_cleaned_7.png";
import certCisco from "../../Assets/cert_cleaned_8.png";
import certstorage from "../../Assets/cert_cleaned_9.png";
import certnetwork from "../../Assets/cert_cleaned_3.png";
import certentra from "../../Assets/cert_cleaned_11.png";
import docker from "../../Assets/dock-1.png";
import kubernetes from "../../Assets/k8s-1.png";
import Terraform from "../../Assets/terra-1.png";
import jenk from "../../Assets/jenk.png";
import ansible from "../../Assets/ans-1.png";




// مكون الشهادات

function AboutCard() {
  // مجموعة Microsoft
  const microsoftCerts = [
    
     {
      img: certAZ900,
      title: "Microsoft Certified: Azure Fundamentals (AZ-900)",
      link: "https://learn.microsoft.com/en-us/users/amrmedhatamer-6465/credentials/c9b9dc9c862e874e",
    },
    {
      img: certSC900,
      title: "Microsoft Certified: Security & Compliance (SC-900)",
      link: "https://learn.microsoft.com/api/credentials/share/en-gb/AmrMedhatAmer-6465/196DD756984E24C6?sharingId=51456AE94AF17917",
    },
    {
      img: certAZ104,
      title: "Microsoft Certified: Azure Administrator (AZ-104)",
      link: "https://learn.microsoft.com/api/credentials/share/en-gb/AmrMedhatAmer-6465/AF3F6D464D57A52E?sharingId=51456AE94AF17917",
    },
       {
      img: certstorage,
      title: "Microsoft Applied Skills: Secure storage for Azure Files and Azure Blob Storage",
      link: "https://learn.microsoft.com/api/credentials/share/en-gb/AmrMedhatAmer-6465/AF3F6D464D57A52E?sharingId=51456AE94AF17917",
    },
       {
      img: certnetwork,
      title: "Microsoft Applied Skills: Configure secure access to your workloads using Azure networking",
      link: "https://learn.microsoft.com/api/credentials/share/en-gb/AmrMedhatAmer-6465/AF3F6D464D57A52E?sharingId=51456AE94AF17917",
    },
       {
      img: certentra,
      title: "Microsoft Applied Skills: Get started with identities and access using Microsoft Entra",
      link: "https://learn.microsoft.com/api/credentials/share/en-gb/AmrMedhatAmer-6465/AF3F6D464D57A52E?sharingId=51456AE94AF17917",
    },
   
  ];

  // مجموعة Security
  const securityCerts = [
    {
      img: certISC2,
      title: "ISC2 Certified in Cybersecurity",
      link: "https://www.credly.com/badges/996a4897-cef6-4ee9-8b53-ba67260b060c/linked_in_profile",
    },
    {
      img: certCisco,
      title: "Cisco – Junior Cybersecurity Analyst",
      link: "https://www.credly.com/badges/a168d669-461f-48ef-a820-0519886c3ad9",
    },
    {
      img: certCoursera,
      title: "Google Cybersecurity (Coursera)",
      link: "https://www.coursera.org/account/accomplishments/specialization/MME4XM9M9Q54",
    },
  ];

  // مجموعة الكورسات
  const courseCerts = [
    {
      img: certCS50SQL,
      title: "Harvard CS50 SQL",
      link: "https://certificates.cs50.io/62725faa-62de-4923-8dd0-cf636ce3c81b.png?size=A4",
    },
    {
      img: certCS50x,
      title: "Harvard CS50x",
      link: "https://certificates.cs50.io/733a9360-7c57-4bd2-94c4-3ae1508341dd.png?size=letter",
    },
  ];
    const kode = [
    {
      img: docker,
      title: "Docker Training Course - KodeKloud",
      link: "https://learn.kodekloud.com/user/certificate/2ca925ba-bb25-42b6-9cf2-6326d8a66b01",
    },
    {
      img: kubernetes,
      title: "kubernetes Training Course - KodeKloud",
      link: "https://learn.kodekloud.com/user/certificate/348300a6-30fb-4abd-90ba-a630b732e95a",
    },
    {
      img: Terraform,
      title: "Terraform Training Course - KodeKloud",
      link: "https://learn.kodekloud.com/user/certificate/4eb8d5b6-f912-40b8-a190-b5d2d5bc5874",
    },
    {
      img: jenk,
      title: "Jenkins Training Course - KodeKloud",
      link: "https://learn.kodekloud.com/user/certificate/0fcdc3f5-5d7c-4d48-af90-a131008e7788",
    },
    {
      img: ansible,
      title: "Ansible Training Course - KodeKloud",
      link: "https://learn.kodekloud.com/user/certificate/6fd7e746-6cdf-4ae3-a0ea-7a0fdf853a14",
    },
    

  ];

  // دالة لإنشاء كل كارت
  const renderCard = (cert, idx) => (
    <Col key={idx} xs={12} sm={6} md={4} className="d-flex align-items-stretch mb-4">
      <Card
        className="project-card-view w-100 text-center"
        style={{
          backgroundColor: "#1e1e2f",
          borderRadius: "16px",
          boxShadow: "0 4px 24px rgba(199, 112, 240, 0.2)",
          padding: "16px",
        }}
      >
        <Card.Img
          variant="top"
          src={cert.img}
          alt={cert.title}
          style={{
            maxHeight: "260px",
            objectFit: "contain",
            borderRadius: "12px",
            marginBottom: "15px",
          }}
        />
        <Card.Body>
          <Card.Title
            style={{
              color: "#c770f0",
              fontSize: "1.1rem",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            {cert.title}
          </Card.Title>
          <Button
            variant="outline-light"
            href={cert.link}
            target="_blank"
            style={{
              color: "#c770f0",
              borderColor: "#c770f0",
              fontSize: "0.9rem",
              padding: "6px 16px",
              transition: "0.3s",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#c770f0";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#c770f0";
            }}
          >
            View Certificate
          </Button>
        </Card.Body>
      </Card>
    </Col>
  );

  // الجزء الظاهر على الشاشة
  return (
    <Container>
      {/* Microsoft Certifications */}
      <h3 style={{ color: "#c770f0", marginTop: "20px", marginBottom: "20px" }}>
        Microsoft Certifications
      </h3>
      <Row className="justify-content-center">
        {microsoftCerts.map((cert, idx) => renderCard(cert, idx))}
      </Row>

      {/* Security Certifications */}
      <h3 style={{ color: "#c770f0", marginTop: "40px", marginBottom: "20px" }}>
        Security Certifications
      </h3>
      <Row className="justify-content-center">
        {securityCerts.map((cert, idx) => renderCard(cert, idx))}
      </Row>

      {/* Harvard */}
      <h3 style={{ color: "#c770f0", marginTop: "40px", marginBottom: "20px" }}>
        Harvard Certifications
      </h3>
      <Row className="justify-content-center">
        {courseCerts.map((cert, idx) => renderCard(cert, idx))}
      </Row>


            {/* kode */}
      <h3 style={{ color: "#c770f0", marginTop: "40px", marginBottom: "20px" }}>
        KodeKloud Certifications
      </h3>
      <Row className="justify-content-center">
        {kode.map((cert, idx) => renderCard(cert, idx))}
      </Row>


    </Container>
    
  );
  
}

export default AboutCard;
